export default __webpack_public_path__ + "static/media/handAndCoin.7b64daa4.svg";